export const columns = [
  // {
  //   title: '记录ID',
  //   dataIndex: 'id',
  //   width: 110,
  //   ellipsis: true,
  // },
  {
    title: '配方名称',
    dataIndex: 'formulaName',
    // width: 100,
    ellipsis: true,
  },
  {
    title: '动物类型',
    dataIndex: 'animalTypeName',
    // width: 110,
    ellipsis: true,
  },
  // {
  //   title: '预估人',
  //   dataIndex: 'createUserName',
  //   width: 110,
  //   ellipsis: true,
  // },
  {
    title: '报告id',
    dataIndex: 'reporterNo',
    // width: 170,
    ellipsis: true,
  },
  {
    title: '预估时间',
    dataIndex: 'createTime',
    // width: 170,
    ellipsis: true,
  },
  {
    title: '操作',
    dataIndex: 'x',
    scopedSlots: { customRender: 'x' },
    // width: 100,
    ellipsis: true,
  }
]
// 详情
// 基础信息
export const baseFeild = [
  {name: '记录ID',feild: 'id'},
  {name: '预估时间',feild: 'createTime'},
  {name: '预估人',feild: 'createUserName'},
  {name: '客户名称',feild: 'customerName'}
]
// 饲喂信息
// 基础信息
export const feedBaseFeild = [
  {name: '饲喂程序',feild: 'feedingName'},
  {name: '关联的饲喂批次',feild: 'feedingBatchNo'},
  {name: '动物类型',feild: 'animalTypeName'},
  {name: '品种',feild: 'varietyName'},
  {name: '猪舍类型',feild: 'hogHouseType'},
  {name: '地板类型',feild: 'hogHouseType'},
  {name: '栏舍类型',feild: 'columnShearType'},
  {name: '场地环境',feild: 'columnShearType'},
  {name: '饲料形态',feild: 'fodderForm'},
  {name: '与农场实际情况',feild: 'identical'},
]
// 饲喂列表
export const feedColumns = [
  {
    title: '开始体重（kg）',
    dataIndex: 'startWeight',
    width: 110,
    ellipsis: true,
  },
  {
    title: '结束体重（kg）',
    dataIndex: 'endWeight',
    width: 110,
    ellipsis: true,
  },
  {
    title: '选择配方',
    dataIndex: 'f3',
    width: 110,
    ellipsis: true,
    scopedSlots: { customRender: 'f3' },
  },
  {
    title: '配方来源工厂',
    dataIndex: 'factoryName',
    width: 170,
    ellipsis: true,
  }
]
// 输入信息
// 营养系统
export const inputNutritionSystem = [
  {name: '能量体系',feild: 'energySystem',codeKey: 'EnergySystem'},
  {name: '氨基酸模式',feild: 'aminoAcidSystem',codeKey: 'AminoAcidSystem'},
  {name: '磷模式',feild: 'phosphorusSystem',codeKey: 'PhosphorusSystem'},
]

// 性别
export const inputSex = [
  {name: '性别',feild: 'genderOption',codeKey: 'genderOption',filter: true},
  {name: '小母猪比例',feild: 'giltsProportion',unit: '%'},
  {name: '阉公猪比例',feild: 'barrowsProportion',unit: '%'},
  {name: '未阉公猪比例',feild: 'entireMalesProportion',unit: '%'},
]
// 采食量
export const inputFeedIntake = [
  {name: '采食/采食+浪费',feild: 'feedintakeDividedByFeedintakeAndWastage',unit: '%',filter: true},
  {name: '采食量模式',feild: 'currentFeedIntakeOption',codeKey: 'currentFeedIntakeOption',filter: true},
  {name: '观测采食曲线类型',feild: 'observedMeanIntakeCurvetype',codeKey: 'observedMeanIntakeCurveType'},
  {name: '观测采食曲线',feild: 'actualMeanIntakeOrIntakeCurve',codeKey: 'actualMeanIntakeOrIntakeCurve'},
  
  {name: '实际平均采食量+浪费量',feild: 'actualMeanFeedIntakeAndWastage'},
  {name: '平均日粮[能量体系名称]含量',feild: 'meanDietEnergyContent'},
  {name: '观测平均采食量对应的初始体重',feild: 'bwinitialActualMeanIntakeInput'},
  {name: '观测平均采食量对应的结束体重',feild: 'bwfinalActualMeanIntakeInput'},


  {name: '考虑环境温度',feild: 'considerEnvironmentalTemperature'},
  {name: '环境温度',feild: 'envTemp',unit: '℃'},
  {name: '考虑饲养密度',feild: 'considerPigSpace'},
  {name: '饲养密度',feild: 'pigSpace',unit: '㎡/猪'},
]
// 蛋白沉积模型
export const inputProtein = [
  {name: '蛋白沉积模型',feild: 'currentPdPatternNumber',codeKey: 'CurrentPDPatternNumber',filter: true},
  {name: '最大蛋白沉积量',feild: 'pdMaxinput',unit: 'g/天'},
  {name: '最大蛋白沉积量开始下降的体重',feild: 'bwatstartpdMaxdeclineinput',unit: 'kg'},
  {name: '平均蛋白沉积量',feild: 'userDefinedMeanpd',unit: 'g/天'},
]
// 观测的生长性能
export const inputGrowthProperties = [
  {name: '生长性能评估模式',feild: 'currentGrowthPerformanceNumber',codeKey: 'CurrentGrowthPerformanceNumber',filter: true},
  {name: '初始体重',feild: 'startingBw',unit: 'kg'},
  {name: '出栏体重',feild: 'slaughterbw',unit: 'kg'},
  {name: '胴体背膘厚',feild: 'probebackfatatfinal',unit: 'mm'},
  {name: '饲养周期',feild: 'daystarttosla',unit: '天'},
]
// 目标体重区间
export const inputColumns = [
  {
    title: ' ',
    dataIndex: 'f1',
    width: 170,
    ellipsis: true,
  },
  {
    title: '开始体重（kg）',
    dataIndex: 'initialBwforaa',
    width: 110,
    ellipsis: true,
  },
  {
    title: '结束体重（kg）',
    dataIndex: 'finalBwforaa',
    width: 110,
    ellipsis: true,
  }
]
// 预估结果
export const resultsGrowProperties = [
  {
    title: '指标',
    dataIndex: 'name',
    scopedSlots: { customRender: `name` },
    width: 160,
    ellipsis: true,
  },
  {
    title: '单位',
    dataIndex: 'unit',
    width: 80,
    ellipsis: true,
  },
  {
    title: '预估值',
    dataIndex: 'predictedValue',
    scopedSlots: { customRender: `predictedValue` },
    width: 120,
  },
  {
    title: '观测值',
    dataIndex: 'observedValue',
    scopedSlots: { customRender: `observedValue` },
    width: 120,
  },
  
]
export const resultsGrowPropertiesList=[
  {name:'初始体重',unit:'kg',field1: 'Startingbodyweight',field2: 'Startingbodyweight',chart: 'weightSeries'},
  {name:'出栏体重',unit:'kg',field1: 'Slaughterbodyweight',field2: 'Slaughterbodyweight'},
  {name:'胴体背膘厚',unit:'mm',field1: 'Probebackfatatslaughterbodywt',field2: 'Probebackfatatslaughterbodywt'},
  {name:'饲养周期',unit:'天',field1: 'Daysfromstartingtoslaughterbodyweight',field2: 'Daysfromstartingtoslaughterbodyweight'},
  {name:'平均日增重',unit:'g/天',field1: 'Averagebodyweightgain',field2: 'Averagebodyweightgain',chart: 'avgSeries'},
  {name:'平均日瘦肉增重',unit:'g/天',field1: 'Averageoverallleantissuegain',field2: 'Averageoverallleantissuegain'},
  // {name:'平均日瘦肉增重',unit:'g/天',field1: 'Averagebodyweightgain',field2: 'Averagebodyweightgain'},
]
// 期望预估结果
export const expectationEstimationColumns = [
  {
    title: '指标',
    dataIndex: 'name',
    width: 160,
    ellipsis: true,
  },
  {
    title: '单位',
    dataIndex: 'unit',
    width: 80,
  },
]
// 哺乳母猪
export const sucklingExpectationEstimationList = [
  {id:1,name: '开始体重',unit: 'kg',field:'initialbw'},
  {id:2,name: '结束体重',unit: 'kg',field:'finalsowbwout'},
  {id:3,name: '平均日粮【能量体系名称】浓度',unit: 'kcal/kg',field:'avgDietEout',startStr: '平均日粮',endStr: '浓度'},
  {id:4,name: '平均【能量体系名称】日摄入量',unit: 'kcal/天',field:'avgEintakeout',startStr: '平均',endStr: '日摄入量'},
  {id:5,name: '平均采食+浪费量',unit: 'kg/天',field:'fifwOut'},
  {id:6,name: '平均母猪日增重',unit: 'g/天',field:'avgadgout'},
  {id:7,name: '平均母猪体蛋白沉积',unit: 'g/天',field:'avgbpdout'},
  {id:8,name: '平均母猪体脂肪沉积',unit: 'g/天',field:'avgbldout'},
  {id:9,name: '平均产奶量',unit: 'kg/天',field:'avgMilkProductionout'},
]
export const expectationEstimationList = [
  {id:1,name: '开始体重',unit: 'kg',field1:'initialBwDb',field2:'initialBwDbOb'},
  {id:2,name: '结束体重',unit: 'kg',field1:'finalBwDb',field2:'finalBwDbOb'},
  {id:3,name: '饲养周期',unit: '天',field1:'daysfrominitofin',field2:'daysOb'},
  {id:4,name: '当前配方【能量体系名称】含量',unit: 'kcal/kg',field1:'avgDietE',field2:'avgDietEob'},
  {id:5,name: '平均【能量体系名称】日摄入量',unit: 'kcal/天',field1:'avgEintake',field2:'avgEintakeob'},
  {id:6,name: '平均【能量体系名称】摄入/参考能量摄入比',unit: '%',field1:'avgintakeOfRefintake',field2:''},
  {id:7,name: '平均日采食量（ADFI）',unit: 'kg/天',field1:'avgFeedintake',field2:'avgFeedintakeob'},
  {id:8,name: '平均日增重（ADG）',unit: 'g/天',field1:'avgAdgDay',field2:'avgAdgOb'},
  {id:9,name: '平均肉料比（G/F）',unit: 'g/g',field1:'avgGainfeed',field2:'avggainfeedOb'},
  {id:'9-1',name: '平均料肉比（F/G）',unit: 'g/g',field1:'feedAvgGain',field2:'feedAvggainOb'},
  {id:10,name: '平均日蛋白沉积',unit: 'g/天',field1:'avgPd',field2:''},
  {id:11,name: '平均日瘦肉增重',unit: 'g/天',field1:'avgLeanGain',field2:''},
  {id:12,name: '平均日体脂肪沉积',unit: 'g/天',field1:'avgLd',field2:''},
]

export const expectationEstimationListCopy = [
  {id:1,name: '平均【能量体系名称】日摄入量',unit: 'kcal/天',field1:'avgEintake',field2:'avgEintakeob'},
  {id:2,name: '平均日采食量（ADFI）',unit: 'kg/天',field1:'avgFeedintake',field2:'avgFeedintakeob'},
  {id:3,name: '当前配方【能量体系名称】含量',unit: 'kcal/kg',field1:'dietE',field2:''},
]

// 期望预估结果 氨基酸
export const aminoAcidColums = [
  {
    title: '指标',
    dataIndex: 'name',
    width: 150,
    fixed: 'left',
    scopedSlots: { customRender: `name` },
    ellipsis: true,
  },
]
export const aminoAcidList = [
  {name: '赖氨酸（Lys）',field: 'Lys'},
  // {name: '精氨酸（Arg）',field: 'Arg'},
  // {name: '组氨酸（His）',field: 'His'},
  // {name: '异亮氨酸（Ile）',field: 'Ile'},
  // {name: '亮氨酸（Leu）',field: 'Leu'},
  {name: '蛋氨酸（Met）',field: 'Met'},
  // {name: '蛋氨酸（Met）+半胱氨酸（Cys）',field: 'MetCys'},
  // {name: '苯丙氨酸（Phe）',field: 'Phe'},
  // {name: '苯丙氨酸（Phe）+酪氨酸（Tyr）',field: 'PheTyr'},
  {name: '苏氨酸（Thr）',field: 'Thr'},
  {name: '色氨酸（Trp）',field: 'Trp'},
  {name: '缬氨酸（Val）',field: 'Val'},
  // {name: '氮（N）',field: 'N'},
  {name: '总钙（Ca）',field: 'Ca'},
  {name: '磷（P）',field: 'P'},
  // {name: '赖能比（LysofE）',field: 'LysofE'},
]
// 矿物质
export const mineralColums = [
  {
    title: '指标',
    dataIndex: 'name',
    width: 100,
    fixed: 'left',
  },
]
export const mineralList = [
  {name: '钠（Na）',field: 'na',dietUnit: '%',dayUnit:'g/天'},
  {name: '氯（Cl）',field: 'cl',dietUnit: '%',dayUnit:'g/天'},
  {name: '镁（Mg）',field: 'mg',dietUnit: '%',dayUnit:'g/天'},
  {name: '钾（K）',field: 'k',dietUnit: '%',dayUnit:'g/天'},
  {name: '铜（Cu）',field: 'cu',dietUnit: 'mg/kg',dayUnit:'mg/天'},
  {name: '碘（I）',field: 'i',dietUnit: 'mg/kg',dayUnit:'mg/天'},
  {name: '铁（Fe）',field: 'fe',dietUnit: 'mg/kg',dayUnit:'mg/天'},
  {name: '锰（Mn）',field: 'mn',dietUnit: 'mg/kg',dayUnit:'mg/天'},
  {name: '硒（Se）',field: 'se',dietUnit: 'mg/kg',dayUnit:'mg/天'},
  {name: '锌（Zn）',field: 'zn',dietUnit: 'mg/kg',dayUnit:'mg/天'},
]
// 维生素
export const vitaminColums = [
  {
    title: '指标',
    dataIndex: 'name',
    width: 150,
    fixed: 'left',
  },
]
export const vitaminList = [
  {name: '维生素A（VA）',field: 'va',dietUnit: 'IU/kg',dayUnit:'IU/天'},
  {name: '维生素D（VD）',field: 'vd',dietUnit: 'IU/kg',dayUnit:'IU/天'},
  {name: '维生素E（VE）',field: 've',dietUnit: 'IU/kg',dayUnit:'IU/天'},
  {name: '维生素K（VK）',field: 'vk',dietUnit: 'mg/kg',dayUnit:'mg/天'},
  {name: '生物素（VH）',field: 'vb7',dietUnit: 'mg/kg',dayUnit:'mg/天'},
  {name: '胆碱（Choline）',field: 'choline',dietUnit: 'g/kg',dayUnit:'g/天'},
  {name: '叶酸（Folacin）',field: 'folacin',dietUnit: 'mg/kg',dayUnit:'mg/天'},
  {name: '烟酸/尼克酸（Niacin）',field: 'niacin',dietUnit: 'mg/kg',dayUnit:'mg/天'},
  {name: '泛酸（VB5）',field: 'vb5',dietUnit: 'mg/kg',dayUnit:'mg/天'},
  {name: '核黄素B2（VB2）',field: 'vb2',dietUnit: 'mg/kg',dayUnit:'mg/天'},
  {name: '硫胺酸（VB1）',field: 'vb1',dietUnit: 'mg/kg',dayUnit:'mg/天'},
  {name: '维生素B6（VB6）',field: 'vb6',dietUnit: 'mg/kg',dayUnit:'mg/天'},
  {name: '维生素B12（VB12）',field: 'vb12',dietUnit: 'μg/kg',dayUnit:'μg/天'},
  {name: '亚油酸（Linoleic）',field: 'linoleic',dietUnit: '%',dayUnit:'g/天'},
]

//经济效益
export const economicColums=[
  {
    title: '指标',
    dataIndex: 'name',
  },
  {
    title: '单位',
    dataIndex: 'unit',
  }
]
export const economicList=[
// {id:1,name:'当前配方价格',unit:'元/吨',filed:'currentDietPrice'},
// {id:2,name:'当前饲料成本',unit:'元/头',filed:'currentProCost'},
// {id:3,name:'推荐[能量体系名称]水平',unit:'kcal/kg',filed:'lowProCostE'},
// {id:4,name:'推荐配方价格',unit:'元/吨',filed:'lowProCostDietPirce'},
// {id:5,name:'推荐料肉比',unit:'-',filed:'lowProCostFg'},
// {id:6,name:'推荐饲料成本',unit:'元/头',filed:'lowProCost'},
// {id:7,name:'饲料成本降低率',unit:'%',filed:'proCostRatio'},
// {id:8,name:'经济效益提升率',unit:'%',filed:'ecoRatio'},
// {id:9,name:'推荐经济效益',unit:'元/头',filed:'highEco'},
// {id:10,name:'当前经济效益',unit:'元/头',filed:'currentEco',field: 'highEco',field3: 'ecoDiffer',field4: 'ecoRatio'},
{id:11,name:'日粮[能量体系名称]水平',unit:'kcal/kg',filed:'currentE',field: 'lowProCostE',field3: 'eDiffer',field4: 'eRatio'},
{id:12,name:'配方价格',unit:'元/kg',filed:'currentDietPrice',field: 'lowProCostDietPirce',field3: 'dietPirceDiffer',field4: 'dietPirceRatio'},
{id:13,name:'料肉比',unit:'kg/kg',filed:'currentFg',field: 'lowProCostFg',field3: 'fgDiffer',field4: 'fgRatio'},
{id:14,name:'生产成本',unit:'元/头',filed:'currentProCost',field: 'lowProCost',field3: 'costDiffer',field4: 'proCostratio'},
{id:15,name:'经济效益',unit:'元/头',filed:'currentEco',field: 'highEco',field3: 'ecoDiffer',field4: 'ecoRatio'},
// {id:15,name:'经济效益',unit:'元/头',filed:'currentEco',field: 'highECO'},
]
//妊娠母猪
export const pregnantExpectationEstimationList = [
  {id:1,name: '开始体重',unit: 'kg',field:'initialBwDb'},
  {id:2,name: '结束体重',unit: 'kg',field:'finalBwDb'},
  {id:3,name: '平均日粮【能量体系名称】浓度',unit: 'kcal/kg',field:'avgDietE'},
  {id:4,name: '平均【能量体系名称】日摄入量',unit: 'kcal/天',field:'avgEintake'},
  {id:5,name: '平均采食+浪费量',unit: 'kg/天',field:'averagefifw'},
  {id:6,name: '平均总日增重',unit: 'g/天',field:'avgsowadg'},
  {id:7,name: '平均母体日增重',unit: 'g/天',field:'avgmaternalsowadg'},
  {id:8,name: '平均总日体蛋白沉积',unit: 'g/天',field:'avgsowbp'},
  {id:9,name: '平均母体日体蛋白沉积',unit: 'g/天',field:'avgmaternalsowbp'},
  {id:10,name: '平均胎儿日体蛋白沉积',unit: 'g/g',field:'avgbp'},
  {id:11,name: '平均总日体脂肪沉积',unit: 'g/天',field:'avgsowbl'},
  {id:12,name: '平均母体日体脂肪沉积',unit: 'g/天',field:'avgmaternalsowbl'},
]
// 哺乳母猪
export const sucklingResultsGrowPropertiesList=[
  {name:'母猪分娩时体重',unit:'kg',field1: 'sowbodyweightafterfarrowin',field2: 'sowbodyweightafterfarrowin'},
  {name:'断奶时母猪体重',unit:'kg',field1: 'bwatweaningpre',field2: 'bwatweaning',chart: 'weightSeries'},
  {name:'母猪分娩时P2背膘厚',unit:'mm',field1: 'p2backfatatfarrowingpre',field2: 'p2backfatatfarrowing'},
  {name:'断奶时母猪P2背膘厚',unit:'mm',field1: 'p2backfatatweaningpre',field2: 'p2backfatatweaning'},
  {name:'哺乳期体重变化',unit:'kg',field1: 'changeinbwpre',field2: 'changeinbw',},
  {name:'哺乳期背膘厚变化',unit:'mm',field1: 'changeinp2backfatpre',field2: 'changeinp2backfat'},
]
